<template>
    <div
        class="max-w-screen-2xl mx-auto px-10 py-10"
        v-if="partners.length"
    >
        <VueSlickCarousel
            v-bind="voucherOption2"
        >
            <div
                v-for="partner in partners"
                :key="partner"
                class="p-5"
            >
                <div class="bg-white" style="box-shadow: 0 3px 10px rgb(0,0,0,0.2);">
                    <div class="flex font-semibold gap-10 h-24 items-center justify-between p-5 text-black text-xs">
                        {{ partner.username }}
                        <img
                            v-if="partner.company.logo"
                            :src="onSetImage(partner.company.logo)"
                            alt="partner logo"
                            class="w-24"
                        >
                    </div>

                    <VueSlickCarousel
                        v-bind="voucherOption"
                    >
                        <div
                            v-for="v in partner.employee_vouchers"
                            :key="v"
                        >
                            <img
                                :src="onSetImage(v.data_json.background_image)"
                                alt="Employee Vouchers"
                            >
                            <div class="flex flex-col py-5 text-black text-center text-sm">
                                <span class="font-bold">{{ v.title }}</span>
                                <span>{{ v.employee_value }}</span>
                            </div>
                        </div>
                    </VueSlickCarousel>
                </div>
            </div>
        </VueSlickCarousel>
    </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

  export default {
    name: 'PartnersWordPress',
    components: {
      VueSlickCarousel
    },
    data() {
      return {
        partners: [],
        voucherOption: {
            arrows: false,
            dots: false,
            focusOnSelect: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchThreshold: 5,
            rows: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            draggable: false,
        },
        voucherOption2: {
            arrows: false,
            dots: true,
            focusOnSelect: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            touchThreshold: 5,
            rows: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            draggable: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2,
                        arrows: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                    }
                }
            ]
        },
      }
    },
    computed: {
        IS_LOADING() {
        return this.$store.getters.IS_LOADING;
        },
    },
    mounted() {
        this.fetchActivePartners()
    },
    methods: {
        async fetchActivePartners() {
            try {
                await this.$store.commit('SET_CODES', [])
                await this.$store.commit('SET_IS_LOADING', { status: 'open' })

                const { partners } = await this.$store.dispatch('FETCH_ACTIVE_PARTNERS_W_VOUCHERS')

                this.partners = partners

                await this.$store.commit('SET_IS_LOADING', { status: 'close' })
            } catch(error) {
                await this.$store.commit('SET_IS_LOADING', { status: 'close' })
            }
        },
        onSetImage(value) {
            if (!value) {
                return false
            }

            return value.search('base64') < 0
                ? `${process.env.VUE_APP_API_BASE_URL}/storage/${value}`
                : value;
            },
        }
  }
</script>
<style lang='css' scoped>
</style>